import type { ConditionalFormTicketProps } from './api/conditionalFormApi'
import { ConditionalFormConfigSchema } from './api/conditionalFormApi'
import { getVisibleSectionIds } from './conditionalFormSection/conditionalFormVisibility'

export function isConditionalFormStepComplete(params: {
  config: unknown
  fieldValues: ConditionalFormTicketProps['fieldValues']
}): boolean {
  const parsedConfig = ConditionalFormConfigSchema.safeParse(params.config)
  if (!parsedConfig.success) {
    return false
  }

  const { sections, form } = parsedConfig.data
  const visibleSectionIds = getVisibleSectionIds(form, params.fieldValues ?? {})

  return visibleSectionIds.every((sectionId) => {
    const section = sections.find((s) => s.id === sectionId)
    if (!section) {
      return true
    }
    return section.fields.every((field) => {
      const value = params.fieldValues?.[field]
      return value !== undefined && value !== null && value !== ''
    })
  })
}
